
























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import VueApexCharts from 'vue-apexcharts';
import { AgencyType, IAgency, IUser, UserRoleType } from 'admiral-core';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  Edit2Icon,
  LinkIcon,
  MailIcon,
  MoveIcon,
  SettingsIcon,
  UserIcon,
} from 'vue-feather-icons';
import ContextMenu from '@/components/common/ContextMenu.vue';
import Avatar from '@/components/common/Avatar.vue';
import { ApexOptions } from 'apexcharts';
import { AdminApi } from '@/services/AdminApi';
import dayjs from 'dayjs';
import { Util } from '@/utils/Util';
import AgencyStatusBadge from '@/components/common/AgencyStatusBadge.vue';

@Component({
  components: {
    AgencyStatusBadge,
    Avatar,
    ContextMenu,
    SettingsIcon,
    MoveIcon,
    apexchart: VueApexCharts,
    ChevronDownIcon,
    ChevronUpIcon,
    LinkIcon,
    Edit2Icon,
    MailIcon,
    UserIcon,
  },
})
export default class AgencyDetail extends Vue {
  @Prop({ type: Object })
  agency!: IAgency & { totalFileSize: number };

  series: ApexAxisChartSeries = [];
  loading = false;

  activityVisible = false;

  async loadResult() {
    try {
      const result = await AdminApi.getAgencyActivity({
        agency: this.agency,
      });
      const data = result.data;
      const logins: number[] = [];
      const createdPolicies: number[] = [];
      const createdTasks: number[] = [];
      const createdDamages: number[] = [];
      const createdComments: number[] = [];
      const createdFiles: number[] = [];
      Object.keys(data).forEach((item: string) => {
        logins.push(Number(data[item].logins) || 0);
        createdPolicies.push(Number(data[item].createdPolicies) || 0);
        createdTasks.push(Number(data[item].createdTasks) || 0);
        createdDamages.push(Number(data[item].createdDamages) || 0);
        createdComments.push(Number(data[item].createdComments) || 0);
        createdFiles.push(Number(data[item].createdFiles) || 0);
      });

      this.series = [
        {
          name: 'Anzahl Logins',
          data: logins,
        },
        {
          name: 'Anzahl angelegte Anbahnungen',
          data: createdPolicies,
        },
        {
          name: 'Anzahl angelegte Aufgaben',
          data: createdTasks,
        },
        {
          name: 'Anzahl angelegte Schäden',
          data: createdDamages,
        },
        {
          name: 'Anzahl angelegte Kommentare',
          data: createdComments,
        },
        {
          name: 'Anzahl angelegte Dateien',
          data: createdFiles,
        },
      ];

      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          categories: Object.keys(data),
          labels: {
            formatter: function (value) {
              const day = dayjs(value);
              const days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
              if (day.day() === 1) {
                return 'Mo, ' + dayjs(value).format('DD.MM');
              }
              return days[day.day()];
            },
          },
        },
      };
    } catch (e) {
      console.log(e);
    }
  }

  agencyType(type: AgencyType) {
    return Util.formatAgencyType(type);
  }

  async mounted() {
    // await this.loadResult();
  }

  chartOptions: ApexOptions = {
    chart: {
      height: 250,
      type: 'line',

      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    title: {
      text: 'Aktivität (letzte 30 Tage)',
      offsetY: 10,
      offsetX: 10,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [3, 3, 3],
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: [],
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: true,
      },
    },

    grid: {
      borderColor: '#f1f1f1',
    },
  };
  getDate(date: Date) {
    return Util.formatDate(date);
  }
  getAgencyAdmin(agency: IAgency) {
    return agency.users.filter((user: IUser) => user.role.type === UserRoleType.ADMIN);
  }

  getAgencyNotAdmin(agency: IAgency) {
    return agency.users.filter((user: IUser) => user.role.type !== UserRoleType.ADMIN);
  }
  editAgency() {
    this.$emit('edit-agency', this.agency);
  }
  loadAgencyActivity() {
    this.activityVisible = true;
    this.loadResult();
  }
}
